import { render, staticRenderFns } from "./IconCheckSquare.vue?vue&type=template&id=06899564&"
import script from "./IconCheckSquare.vue?vue&type=script&lang=js&"
export * from "./IconCheckSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports